import React from 'react';
import { Field } from 'react-final-form';
import CreatableSelect from 'react-select/creatable';

// Inner component defined outside to prevent remounting on every render
const FieldCreatableSelect = ({
  input,
  meta,
  options,
  isMulti,
  placeholder,
  label,
  isCreateNewFieldDisable,
  closeMenuOnSelect,
  hideSelectedOptions,
  menuPortalTarget,
  menuShouldBlockScroll,
}) => {
  const handleChange = (selectedOptions) => {
    input.onChange(selectedOptions);
  };

  const isCreateFieldDisabled = isCreateNewFieldDisable ? {
    isValidNewOption: () => false,
    formatCreateLabel: () => "",
  } : {};

  return (
    <div>
      {label ? <label>{label}</label> : null}
      <CreatableSelect
        placeholder={placeholder}
        isMulti={isMulti}
        options={options}
        value={input.value || []}
        onChange={handleChange}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        menuPortalTarget={menuPortalTarget}
        menuShouldBlockScroll={menuShouldBlockScroll}
        styles={menuPortalTarget ? { menuPortal: base => ({ ...base, zIndex: 9999 }) } : undefined}
        {...isCreateFieldDisabled}
      />
      {meta.touched && meta.error && <span>{meta.error}</span>}
      {meta.touched && meta.warning && <span>{meta.warning}</span>}
    </div>
  );
};

// A reusable custom field component to integrate CreatableSelect with Final Form
const FieldMultiSelectCreate = ({
  name,
  options = [],
  isMulti = true,
  validate,
  label = "",
  placeholder = "select or add new item",
  isCreateNewFieldDisable = false,
  closeMenuOnSelect = true,
  hideSelectedOptions = true,
  menuPortalTarget,
  menuShouldBlockScroll = false,
}) => {
  return (
    <Field
      name={name}
      validate={validate}
      render={({ input, meta }) => (
        <FieldCreatableSelect
          input={input}
          meta={meta}
          options={options}
          isMulti={isMulti}
          placeholder={placeholder}
          label={label}
          isCreateNewFieldDisable={isCreateNewFieldDisable}
          closeMenuOnSelect={closeMenuOnSelect}
          hideSelectedOptions={hideSelectedOptions}
          menuPortalTarget={menuPortalTarget}
          menuShouldBlockScroll={menuShouldBlockScroll}
        />
      )}
    />
  );
};

export default FieldMultiSelectCreate;
